var _style, _polygon, _polygon2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190.1 173.9",
    style: {
      enableBackground: "new 0 0 190.1 173.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD0028;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#5D5D5D;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "95.1,0 152.1,147.7 0,161.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "151.8,147.7 190.3,161.8 95.1,0 151.3,145.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-0.2,161.6l151.8-13.9l38.5,14.1c0,0-135.8,11.5-139.8,12.1C46.3,174.4-0.2,161.6-0.2,161.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxLogo);
export default __webpack_public_path__ + "static/media/box_logo.68ea5559020a62c367d5f3cb7d02650d.svg";
export { ForwardRef as ReactComponent };